<div class="loginForm">
    <app-formular [formBuilderInput]="modelInput" [formular]="formular" [groupName]="'LOGIN'" (action)="action($event)" [groupName]="groupName">
    </app-formular>
    <div style ="padding-left: 15px;">
        <div style="display: flex;">
            <mat-checkbox color="primary" class="formItem formCheckbox" [formControl]="modelInput.controls.AcceptTermOfUse">
            </mat-checkbox>
            <div style="display: flex; padding-left: 5px; padding-top: 1px;" [innerHTML]="getAcceptTermOfUse()" (click)="download($event)"></div>
        </div>
        <div style="display: flex;">
            <mat-checkbox color="primary" class="formItem formCheckbox" [formControl]="modelInput.controls.ReadDataProtection">
            </mat-checkbox>
            <div style="display: flex; padding-left: 5px; padding-top: 1px;" [innerHTML]="getReadDataProtection()" (click)="download($event)"></div>
        </div>
    </div>
    <section class="example-section">
        <button mat-raised-button color="primary" (click)="login()" [disabled]="!isLoginEnabled()">{{'Login_BUT' | translateResourceDefinition: resourceDefinition : "KEY_NAME" : "LONG_TEXT" : "LOGIN"}}</button>
    </section>
    <br>
</div>